// extracted by mini-css-extract-plugin
module.exports = {"Title":"title-module--Title--25Oo5"};